import dayjs from 'dayjs';

// 新年裝飾結束日期
const NEW_YEAR_DECORATION_END_DATE = '2026-02-26';

// 判斷是否已過新年裝飾結束日期
export const isExpiredNewYear = () => {
  return dayjs().isAfter(dayjs(NEW_YEAR_DECORATION_END_DATE));
};
